import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("#rank");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`border-b transition-colors duration-300 ${
          scrolled
            ? "bg-background-50/90 border-background-200 backdrop-blur"
            : "bg-background-50/60 border-transparent"
        }`}
      >
        <div className="mx-auto flex h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜王 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="fa-solid fa-crown text-sm"></i>
            </span>
            <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950">
              吃瓜王
            </h1>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => {
              const isActive = active === link.href;
              return (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setActive(link.href)}
                  className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                    isActive
                      ? "bg-background-200/80 text-foreground-950 font-medium"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {link.label}
                </a>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#today"
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill"></i>
              订阅吃瓜提醒
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="菜单"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="block rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}